import keys from 'lodash/keys.js';
import merge from 'lodash/merge.js';

import axios from '@/plugins/axios.js';
import Video from '@/store/modules/videos/Video.js';
import Collection from '@/store/quill/Collection.js';
import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('video');

export default merge(Collection('Videos', Video), {
    state: {
        sort: {
            id: null,
            title: null,
            caption: null,
            updated_at: null,
        },
    },

    getters: {
        ...collectionHelpers.getters,
    },

    actions: {
        clearSort: collectionHelpers.actions.clearSort,

        addVideo: collectionHelpers.actions.addModel(null, true),

        paginateAndFetch: collectionHelpers.actions.paginateAndFetch,

        fetch: collectionHelpers.actions.fetch(({ context, queryBuilder }) => {
            const { getters, rootGetters } = context;

            queryBuilder
                .include(['tags', 'groups', 'courseCodes'])
                .sort(getters.queryBuilderSorting)
                .setPagination(getters.paginate);

            if (rootGetters['VideosView/hasQuery']) {
                queryBuilder.raw({
                    search: rootGetters['VideosView/searchQuery'],
                });
            }

            if (rootGetters['VideosView/hasTagSearch']) {
                queryBuilder.raw({
                    tags: rootGetters['VideosView/searchTag'],
                });
            }

            if (rootGetters['VideosView/hasGroupSearch']) {
                queryBuilder.raw({
                    groups: rootGetters['VideosView/searchGroup'],
                });
            }

            if (rootGetters['VideosView/hasViewArchive']) {
                queryBuilder.raw({
                    view_archived: rootGetters['VideosView/searchViewArchive'],
                });
            }
        }),

        fetchOne: collectionHelpers.actions.fetchOne(({ queryBuilder }) => {
            queryBuilder.include(['tags', 'groups']);
        }),

        updateTags: collectionHelpers.actions.updateModelTags(),

        updateCourseCodes: collectionHelpers.actions.updateModelCourseCodes(),

        updateGroups: collectionHelpers.actions.updateModelGroups(),

        removeChecked: collectionHelpers.actions.removeChecked(),

        async processVideo(context, uuid) {
            const item = context.getters.get(uuid);

            const payload = new FormData();

            const video = new Blob([item.video], {
                type: item.video?.type || '',
            });

            keys(item).forEach(key => (key === 'video' ? payload.append(key, video) : payload.append(key, item[key])));

            const data = await context.dispatch('addVideo', payload);

            if (item.tags) {
                await context.dispatch('updateTags', {
                    subject: data,
                    tags: item.tags,
                    modelKey: 'reference_id',
                });
            }

            if (item.course_codes) {
                await context.dispatch('updateCourseCodes', {
                    subject: data,
                    course_codes: item.course_codes,
                    modelKey: 'reference_id',
                });
            }

            if (item.groups) {
                await context.dispatch('updateGroups', {
                    subject: data,
                    groups: item.groups,
                    modelKey: 'reference_id',
                });
            }
            return data;
        },

        async syncCourseCodes(context, { video, paramKey, courseCodes }) {
            await context.dispatch('AutoSave/setSaving', `${Collection}/updateGroups`, { root: true });

            await axios.put(`/api/videos/${video.reference_id}`, {
                reference_id: video.reference_id,
                title: video.title,
                [paramKey]: courseCodes,
            });

            await context.dispatch('AutoSave/setSaved', `${Collection}/updateGroups`, { root: true });

            await context.dispatch('fetch');
        },

        /**
         * @param context
         * @param filter
         * @return {Promise<any>}
         */
        async filterAndFetch(context, filter) {
            try {
                await context.dispatch('filter', filter);
                await context.dispatch('purge');
                await context.dispatch('fetch');
            } catch (error) {
                return error;
            }
        },
    },

    mutations: {
        UPDATE_TAGS: collectionHelpers.mutations.UPDATE_TAGS,
        UPDATE_GROUPS: collectionHelpers.mutations.UPDATE_GROUPS,
        CLEAR_SORTING: collectionHelpers.mutations.CLEAR_SORTING,
        UPDATE_COURSE_CODES: collectionHelpers.mutations.UPDATE_COURSE_CODES,

        AUTO_SAVE() {
            // Use to trigger auto save
        },
    },
});
